import { render, staticRenderFns } from "./platform-dropdown.vue?vue&type=template&id=a15174ae&scoped=true&"
import script from "./platform-dropdown.vue?vue&type=script&lang=js&"
export * from "./platform-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./platform-dropdown.vue?vue&type=style&index=0&id=a15174ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15174ae",
  null
  
)

export default component.exports